import classNames from 'classnames';
import React from 'react';

import { Button, ButtonSizes, ButtonVariant, Icon } from '@/shared/ui';

import { config } from '@/config/index';

import { useBinotel } from '../useBinotel';

import './BinotelStyles.scss';

interface Props {
  className?: string;
}

export const BinotelButton: React.FC<Props> = ({ className }) => {
  const { loadBinotel, triggerBinotelChat } = useBinotel({ hash: config.binotel.hash ?? '' });

  return (
    <Button
      variant={ButtonVariant.ICON}
      size={ButtonSizes.SM}
      className={classNames('binotel-btn', className)}
      onClick={async () => {
        loadBinotel();
        triggerBinotelChat();
      }}
    >
      <Icon name="chat" />
    </Button>
  );
};
